module.exports = __webpack_public_path__ + "static/media/neck4.f0c896e6.png";